"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRevieveScript = void 0;
var _react = require("react");
var _utils = require("../utils");
const SCRIPT_ID = 'revieve-plugin-loader';
const SCRIPT_URL = 'https://d38knilzwtuys1.cloudfront.net/revieve-plugin-v4/revieve-plugin-loader.js';
const getScriptTag = onLoad => {
  let script = document.getElementById(SCRIPT_ID);
  if (script === null) {
    script = document.createElement('script');
    script.async = true;
    script.charset = 'utf8';
    script.id = SCRIPT_ID;
    script.src = SCRIPT_URL;
    script.type = 'text/javascript';
    script.addEventListener('load', onLoad);
  }
  return script;
};
const insertScriptTag = script => {
  const scripts = document.getElementsByTagName('script');
  const firstScript = scripts.item(0);
  if (!firstScript?.parentNode?.contains(script)) {
    firstScript?.parentNode?.insertBefore(script, firstScript);
  }
};
const useRevieveScript = ({
  initConfig,
  onInit
}) => {
  const onLoad = (0, _react.useCallback)(() => (0, _utils.initRevieve)(initConfig, onInit), [initConfig, onInit]);
  (0, _react.useEffect)(() => {
    const script = getScriptTag(onLoad);
    insertScriptTag(script);
    return () => {
      (0, _utils.unmountRevieve)();
      script.removeEventListener('load', onLoad);
      script.remove();
    };
  }, [onLoad]);
};
exports.useRevieveScript = useRevieveScript;